<!-- Amíg a bejelentkezés utáni betöltés fut. -->
<div class="landing-varakozas" *ngIf="!elakadt">
  <ion-spinner name="crescent"></ion-spinner>
  <p>Egy pillanat…</p>
</div>

<!--
  Ha a betöltés nem fejeződött be, NEM hagyjuk üresen a képernyőt. Eddig ez a
  képernyő 20 másodperc után egyszerűen ottmaradt, magyarázat és kiút nélkül.
-->
<div class="landing-elakadt" *ngIf="elakadt">
  <ion-icon name="alert-circle-outline"></ion-icon>
  <h2>A betöltés nem fejeződött be</h2>
  <p>
    A bejelentkezés megtörtént, de a rendszer nem kapta meg az intézményi adatokat.
    Ez jellemzően átmeneti: próbáld újra. Ha marad, jelezd a rendszergazdának.
  </p>
  <div class="landing-gombok">
    <ion-button (click)="ujra()">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>Újrapróbálom
    </ion-button>
    <ion-button fill="outline" (click)="belepes()">Bejelentkezés újra</ion-button>
    <ion-button fill="clear" (click)="tisztaBelepes()">Tiszta belépés</ion-button>
  </div>
  <p class="landing-lepes">Elakadt lépés: {{ lepes }}</p>
  <p class="landing-lepes">Ha az újrapróbálás nem segít, a <b>Tiszta belépés</b> törli a telefonon tárolt munkamenetet, és elölről kezdi a belépést.</p>
</div>
